import './process.css';
import * as React from 'react'
import {Component} from "react";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";
import {Header, ProcessElement, ProcessElementArrow, ProcessElementArrowDown} from "../../widgets";


export class Process extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPhone: window.innerWidth < 1000
        }
    }

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('prosess', window.innerWidth < 1000);
        setLogoWhite(false);

        const self = this;

        window.matchMedia('(min-width: 1000px').addEventListener('change', () => {
            self.setState({isPhone: window.innerWidth < 1000});
        });
    }

    render() {
        return (
            <div className={'default-large-cage default-vertical-cage'}>
                <div className={'process'}>
                    <div className={'process-header'}>
                        <Header text={'Prosessen'}/>
                    </div>
                    {this.renderProcess()}
                </div>
            </div>
        )
    }


    renderProcess() {
        if(this.state.isPhone) {
            return (
                <div className={'process-phone'}>
                    <div>
                        <div className={'process-element-phone'}>
                            <div className={'process-element-phone-title'}>
                                1. Brainstorming
                            </div>
                            <div className={'default-horizontal-center'}>
                                <ProcessElement imageURL={'resources/blonomBrain.jpg'} description={'Den enorme mengden uutnyttet restråstoff i form av fiskeblod som produseres i dag, ønsker vi å dra nytte av på en bærekraftig måte.'}/>
                            </div>
                        </div>
                    </div>
                    <div className={'process-element-phone-arrow'}>
                        <ProcessElementArrowDown />
                    </div>
                    <div>
                        <div className={'process-element-phone'}>
                            <div className={'process-element-phone-title'}>
                                2. Analyse
                            </div>
                            <div className={'default-horizontal-center'}>
                                <ProcessElement imageURL={'resources/blonomAnalysis.jpg'} description={'Vi kartlegger markedet, og finner ut hvorvidt vårt produkt passer dette markedet.'}/>
                            </div>
                        </div>
                    </div>
                    <div className={'process-element-phone-arrow'}>
                        <ProcessElementArrowDown />
                    </div>
                    <div>
                        <div className={'process-element-phone'}>
                            <div className={'process-element-phone-title'}>
                                3. Ressurser
                            </div>
                            <div className={'default-horizontal-center'}>
                                <ProcessElement imageURL={'resources/blonomResources.jpg'} description={'Vi anskaffer oss tilgang på nødvendige ressurser i form av råstoff, utstyr og kunnskap.'}/>
                            </div>
                        </div>
                    </div>
                    <div className={'process-element-phone-arrow'}>
                        <ProcessElementArrowDown />
                    </div>
                    <div>
                        <div className={'process-element-phone'}>
                            <div className={'process-element-phone-title'}>
                                4. Frysetørking
                            </div>
                            <div className={'default-horizontal-center'}>
                                <ProcessElement imageURL={'resources/blonomFreeze.jpg'} description={'Ved frysetørking, en prosess hvor blodet fryses og tørkes i en maskin, evner vi å fremstille et pulver av fiskeblodet.'}/>
                            </div>
                        </div>
                    </div>
                    <div className={'process-element-phone-arrow'}>
                        <ProcessElementArrowDown />
                    </div>
                    <div>
                        <div className={'process-element-phone'}>
                            <div className={'process-element-phone-title'}>
                                5. Produktet
                            </div>
                            <div className={'default-horizontal-center'}>
                                <ProcessElement imageURL={'resources/blonomBag.jpg'} description={'Det endelige produktet er et forbruksvennlig kosttilskuddspulver for tilsettelse i dyrefor av ulike slag.'}/>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={'process-desktop'}>
                    <div className={'process-desktop-elements'}>
                        <div>
                            <div className={'process-element-desktop-title'}>
                                1. Brainstorming
                            </div>
                            <div className={'process-element-desktop'}>
                                <ProcessElement imageURL={'resources/blonomBrain.jpg'} description={'Den enorme mengden uutnyttet restråstoff i form av fiskeblod som produseres i dag, ønsker vi å dra nytte av på en bærekraftig måte.'}/>
                            </div>
                        </div>
                        <div className={'process-element-desktop-arrow'}>
                            <ProcessElementArrow />
                        </div>
                        <div>
                            <div className={'process-element-desktop-title'}>
                                2. Analyse
                            </div>
                            <div className={'process-element-desktop'}>
                                <ProcessElement imageURL={'resources/blonomAnalysis.jpg'} description={'Vi kartlegger markedet, og finner ut hvorvidt vårt produkt passer dette markedet.'}/>
                            </div>
                        </div>
                        <div className={'process-element-desktop-arrow'}>
                            <ProcessElementArrow />
                        </div>
                        <div>
                            <div className={'process-element-desktop-title'}>
                                3. Ressurser
                            </div>
                            <div className={'process-element-desktop'}>
                                <ProcessElement imageURL={'resources/blonomResources.jpg'} description={'Vi anskaffer oss tilgang på nødvendige ressurser i form av råstoff, utstyr og kunnskap.'}/>
                            </div>
                        </div>
                        <div className={'process-element-desktop-arrow'}>
                            <ProcessElementArrow />
                        </div>
                        <div>
                            <div className={'process-element-desktop-title'}>
                                4. Frysetørking
                            </div>
                            <div className={'process-element-desktop'}>
                                <ProcessElement imageURL={'resources/blonomFreeze.jpg'} description={'Ved frysetørking, en prosess hvor blodet fryses og tørkes i en maskin, evner vi å fremstille et pulver av fiskeblodet.'}/>
                            </div>
                        </div>
                        <div className={'process-element-desktop-arrow'}>
                            <ProcessElementArrow />
                        </div>
                        <div>
                            <div className={'process-element-desktop-title'}>
                                5. Produktet
                            </div>
                            <div className={'process-element-desktop'}>
                                <ProcessElement imageURL={'resources/blonomBag.jpg'} description={'Det endelige produktet er et forbruksvennlig kosttilskuddspulver for tilsettelse i dyrefor av ulike slag.'}/>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}